var app = angular.module("leonardo");

var LoadingController = function($scope, $timeout) {

  $scope.text = 'Loading your properties...';

  $timeout(function() {
    $scope.text = 'Sorting templates...';
    $timeout(function() {
      $scope.text = 'Finalizing layout...';
    }, 2000);
  }, 3000)

};

app.controller('LoadingController', ['$scope', '$timeout', LoadingController]);
